﻿$(document).ready(function () {
    $(document).on('click', '.js-causes-validation', function (e) {
        var validationGroup = $(this).data('validation-group');
        $('[data-validation-summary]').addClass('alert--hidden');
        if (typeof Page_ClientValidate == 'function') {
            Page_ClientValidate(validationGroup);

            if (!Page_IsValid) {
                $("[data-validation-summary][data-validation-group='" + validationGroup + "']").removeClass('alert--hidden');
            }
        }

        $('form').trigger('postback');
    });

    $(document).on('click', '.js-clears-validation', function (e) {
        $('[data-validation-summary]').addClass('alert--hidden');
        for (var i = 0; i < Page_Validators.length; i++) {
            Page_Validators[i].style.display = "none";
        }
        $('.input-error').removeClass('input-error');
    });

    $('[class$="-validation-summary"]').each(function (i, n) {
        var $summary = $(this);
        var isVisible = $summary.css('display') != 'none';
        var validationGroup = $summary.data('validation-group');
        if (isVisible) {
            $("[data-validation-summary][data-validation-group='" + validationGroup + "']").removeClass('alert--hidden');
        } else {
            $("[data-validation-summary][data-validation-group='" + validationGroup + "']").addClass('alert--hidden');
        }
    });

});

window.validateOnLoad = function (validationGroup) {
    var $summary = $('.' + validationGroup + '-validation-summary');
    var isVisible = $summary.css('display') != 'none';
    if (isVisible) {
        $("[data-validation-summary][data-validation-group='" + validationGroup + "']").removeClass('alert--hidden');
    } else {
        $("[data-validation-summary][data-validation-group='" + validationGroup + "']").addClass('alert--hidden');
    }
}

window.validateOnClick = function(validationGroup) {
    $('[data-validation-summary]').addClass('alert--hidden');;
    if (typeof Page_ClientValidate == 'function') {
        Page_ClientValidate(validationGroup);
        if (!Page_IsValid) {
            $("[data-validation-summary][data-validation-group='" + validationGroup + "']").removeClass('alert--hidden');
        }
    }
}

window.WebForm_OnSubmit = function() {
    if (typeof (SetRadioButtonsIntoOriginalNames) == "function") {
        SetRadioButtonsIntoOriginalNames();
    }

    if (typeof (onCreditCardFormSubmit) == "function") {
        onCreditCardFormSubmit();
    }
    if (typeof (ValidatorOnSubmit) == "function" && ValidatorOnSubmit() == false) {
        var invalidControls = {};
        var invalidValidationSummaries = {};
        for (var i in Page_Validators) {
            try {
                if (Page_Validators[i].controltovalidate == undefined) {
                    invalidValidationSummaries[Page_Validators[i].validationGroup] = Page_Validators[i].validationGroup;
                } else {
                    var control = document.getElementById(Page_Validators[i].controltovalidate);
                    if (control.type == "hidden" && control.className.indexOf('flatpickr-input') >= 0) {
                        control = document.querySelector('#' + control.id + ' + .flatpickr-input[type=text]');
                    }

                    if (invalidControls[control.id] == undefined) {
                        if (!Page_Validators[i].isvalid) {

                            if (control.parentElement.className.indexOf('input--with-icon') >= 0) {
                                control.parentElement.className += " input-error";
                            } else {
                                control.className += " input-error";
                            }
                            invalidControls[control.id] = "invalid";
                            invalidValidationSummaries[Page_Validators[i].validationGroup] = Page_Validators[i].validationGroup;
                        } else {

                            if (control.parentElement.className.indexOf('input--with-icon') >= 0) {
                                control.parentElement.className = control.className.replace('input-error', '');
                            } else {
                                control.className = control.className.replace('input-error', '');
                            }
                        }
                    }
                }
            } catch (e) { }
        }
        $('[data-validation-summary], .alert--manual').addClass('alert--hidden');
        for (var invalid in invalidValidationSummaries) {
            $("[data-validation-summary][data-validation-group='" + invalid + "']").removeClass('alert--hidden');
        }

        if (typeof (SetRadioButtonsIntoGroups) == "function") {
            SetRadioButtonsIntoGroups();
        }

        if (typeof (onCreditCardFormInvalid) == "function") {
            onCreditCardFormInvalid();
        }
        return false;
    }
    return true;
}

